export default {
  Reviews(state) {
    return state.reviewsList
  },
  PaginationMeta(state) {
    return state.reviewsInfo.meta
  },
}
